import {React, useState, useEffect} from 'react';
import { motion,AnimatePresence } from "framer-motion";

import location from '../img/location.png';
import locationSimple from '../img/location-simple.png';
import narrow from '../img/narrow.png';
import MobileNarrow from '../img/m-narrow.png';
import phone from '../img/phone.png';
import storeImage from '../img/storeImage.png';
import UseMediaQuery from "./UseMediaQuery";

function FreeShipping()
{
    const [isOpen, setIsOpen] = useState(false); // مدیریت باز و بسته شدن لیست
    const [StoreTitle,setStoreTitle] = useState('شعب');
    const [animationConfig, setAnimationConfig] = useState({}); // تنظیمات انیمیشن
    const [StoreContent,setStoreContent] = useState(false);

    const branches = [
        {id:1,name:"دفتر مرکزی",phone:["021 - 22 20 66 16","021 - 22 20 66 17"]}, 
        {id:2,name:"شعبه آوا پلت",image:storeImage,address:"خیابان اقدسیه، نبش خیابان فیـروزبخش،مجتمع تجاری آوا پلت طبقه ۱ - واحد B15",phone:["021 - 26 47 04 96"]}, 
        {id:3,name:"شعبه پالادیوم",image:storeImage,address:"زعفرانیه، خیابان مقدس اردبیلی، مرکز خرید پالادیوم، طبقه همکف B، پلاک B13",phone:["021 - 22 66 81 34"]}, 
        {id:4,name:"شعبه پارک سنتـر" ,image:storeImage,address:"فرمانيه، نارنجستان هفتم،پارک سنتـر، طبقه همكف، واحد G09",phone:["021 - 26 37 15 24"]}, 
        {id:5,name:"شعبه اپال" ,image:storeImage,address:"سعادت آباد،مجتمع تجاری اپال، طبقه دوم، واحد 214",phone:["021 - 26 35 09 25"]}, 
        //{id:6,name:"شعبه کوروش" ,image:storeImage,address:"مجتمع تجاری کوروش،طبقه همکف، واحد 37",phone:["021 - 44 03 52 03"]},
        //{id:7,name:"شعبه ونک" ,image:storeImage,address:"میدان ونک، خیابان ونک،بعد از خیابان کار و تجارت، پلاک 74",phone:["021 - 88 79 80 93"]},
        {id:8,name:"شعبه گلستان" ,image:storeImage,address:"شهرک غرب،مجتمع تجاری گلستان، واحد 142",phone:["021 - 88 08 81 85"]},
        {id:9,name:"شعبه کرج" ,image:storeImage,address:"کرج، میدان نبوت،مرکز خرید مهستان، واحد 354",phone:["026 - 32 56 03 54"]} ,
        {id:10,name:"شعبه کیش" ,image:storeImage,address:"کیش، میکامال، طبقه همکف، لاین لبخند، غرفه 475",phone:["076 - 44 48 69 15"]} ,
        {id:11,name:"شعبه مشهد" ,image:storeImage,address:"مشهد، بلوار سجاد، بعد از چهارراه بزرگمهر، نرسیده به شقایق، نبش پاساژ سجاد، پلاک ۱",phone:["051 - 37 68 32 72"]} 
    ];
    const isMobile = UseMediaQuery("(max-width: 768px)");

    const [buttonHeight, setButtonHeight] = useState(!isMobile?76:60);
    const handlemainBranchClick = () => {
        
        
        if(isOpen==true && StoreTitle!='شعب')
        {
           
            setStoreTitle("شعب");
            setAnimationConfig( {
                animate: {opacity:[0,1],height:700},
                exit: {
                    opacity:[1,0],
                    height:700,
                },
                transition: {
                    opacity: { duration: 0.5, ease: "easeIn" },
                }
            });
            setStoreContent(false);
        }
        else
        {
            setAnimationConfig({
                animate: { y:["-100%","-50%","3%","0%"],height:[0,700] },
                exit: { y: "-100%",height:[700,0],opacity:[1,0]},
                transition: {
                    y: { duration: 0.5, ease: "easeOut" },
                    height: { duration: 0.5, ease: "easeOut", stiffness: 100 },
                    opacity: { duration: 0.5, ease: "easeIn" },
                }
            });
            setIsOpen(!isOpen);
        }
        
      
    }
    const handleBranchClick = (branch) => {
        setAnimationConfig( {
            animate: {opacity:[1,0]},
            exit: {},
            transition: {}
        });
        setStoreTitle(branch.name);
        setStoreContent(branch);
    };
   
    useEffect(() => {
        // تنظیم ارتفاع دکمه به‌صورت پویا با استفاده از حالت پیش‌فرض
        const buttonElement = document.getElementById("toggle-button");
        if (buttonElement) {
            setButtonHeight(buttonElement.offsetHeight);
        }
    }, []);

    return(
        <>
        <div className='text-center container mt-5'>
            <img style={isMobile?{width:"35px"}:{}} src={location} />
            <p className='title-free mt-3 mb-0'>ارسال رایگان</p>
            <p className='desc-free'>برای فاکتورهای بالای 30 میلیون تومان به سراسر ایران</p>
        </div>
        <div className='text-center mt-lg-5'>
            <motion.div id="toggle-button" className='stores rounded-3 d-flex justify-content-center align-items-center'  onClick={() => handlemainBranchClick()}
                animate={!isOpen ? { height:[buttonHeight,buttonHeight-25,buttonHeight] } : {}}
                transition= {{
                    duration: 0.6,
                   ease: "easeOut" ,
                    mass: 1,
                    stiffness: 200,
                    damping: 10,
                    delay: 0.3,
                }}
                  >
                
                <span  className='pe-5 w-100'>{StoreTitle}</span>
                <span className='ps-4 flex-shrink-1'><motion.img  animate={{ rotate: !isOpen ? 0 : 180 }} transition= {{duration: 0.3}} src={!isMobile?narrow:MobileNarrow}/></span>
                <i className='icon-down'></i>
            </motion.div>
            {/* لیست شعب */}
            <AnimatePresence  mode="wait">
            {isOpen && (
                <div style={{overflow:"hidden"}}>
                {!StoreContent? (
                    <motion.div
                    //initial={{  height: 0 }}
                    //animate={{ opacity: 1, height: [0,"auto"],y:[0,10,0] }}
                    //initial={{ y:"-100%" }}
                    key="list"
                    animate={animationConfig.animate}
                    exit={animationConfig.exit}
                    transition={animationConfig.transition}
                    style={{
                        marginTop: "10px",
                        borderRadius: "5px",
                        overflow: "hidden",
                    }}
                    >

                    {branches.map((branch, index) => (
                        <div
                        key={index}
                        onClick={() => handleBranchClick(branch)}
                        className='store-title'
                        >
                        {branch.name}
                        </div>
                    ))}
                    </motion.div>
                ):(
                    <motion.div
                        key="content"
                        initial={{ opacity: 0 }}
                        animate={{ opacity: 1 }}
                        exit={{ opacity: 0 }}
                        transition={{ duration: 0.5 }}
                    >
                        <div className='mt-5'>
                            
                            { /*StoreContent.image && (
                                <div>
                                    <img src={StoreContent.image} style={isMobile?{maxWidth:'250px'}:{}}/>
                                </div>
                            )*/}
                            {StoreContent.address && (
                                <>
                                <div className='mt-5'>
                                    <img src={locationSimple} />
                                </div>
                                <p className='store-content mx-auto mt-2'>{StoreContent.address}</p>
                                </>
                            )}
                            {StoreContent.phone && (
                                <>
                                <div>
                                    <img src={phone}/>
                                </div>
                                <div className='mt-3 mx-auto d-flex flex-column store-content'>
                                    {StoreContent.phone.map((phone_no,key)=>(
                                            <a href={"tel:"+phone_no}  dir='ltr'>{phone_no}</a>
                                        )
                                    )}
                                </div>
                                </>
                            )}
                        </div>
                    </motion.div>
                )}
                
                </div>
            )}
             </AnimatePresence>
        </div>
        </>
    );
}
export default FreeShipping;